import { render, staticRenderFns } from "./RoleProfileForm.vue?vue&type=template&id=5f9a7aca&scoped=true&"
import script from "./RoleProfileForm.vue?vue&type=script&lang=js&"
export * from "./RoleProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9a7aca",
  null
  
)

export default component.exports